export default __webpack_public_path__ + "static/media/groundplan_s_84a.66d789e4.png";